export default () => ({
  code: '',
  newPassword: '',
  confirmNewPassword: '',
  isCodeValid: false,
})
